import { FileImageOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { ArticleRow } from '../../api/client';
import StatusBadge from '../../pages/article-list/StatusBadge';
import { fmtTaipei } from '../../pages/article-list/status';

/** 封面縮圖：挑選關聯新聞時，記者多半是看圖認稿，標題不夠。 */
function Cover({ url }: { url?: string | null }) {
  return url ? (
    <img src={url} alt="" loading="lazy" className="h-11 w-16 rounded object-cover" />
  ) : (
    <span className="flex h-11 w-16 items-center justify-center rounded bg-gray-100 text-gray-300">
      <FileImageOutlined />
    </span>
  );
}

export const relatedColumns: ColumnsType<ArticleRow> = [
  { title: '封面', dataIndex: 'coverUrl', width: 84, render: (u?: string | null) => <Cover url={u} /> },
  { title: '標題', dataIndex: 'title', render: (t: string) => <span className="line-clamp-2">{t}</span> },
  { title: '分類', dataIndex: 'categoryNames', width: 110, render: (v?: string | null) => v ?? '—' },
  { title: '作者', dataIndex: 'authorName', width: 100, render: (v?: string | null) => v ?? '—' },
  {
    title: '狀態',
    dataIndex: 'status',
    width: 130,
    render: (s: string, r) => <StatusBadge status={s} scheduledAt={r.scheduledAt} />,
  },
  { title: '更新時間', dataIndex: 'updatedAt', width: 150, render: (t: number) => fmtTaipei(t) },
];

/**
 * 手機版只留一欄：標題（兩行）＋ 下方狀態／日期小字；左邊勾選框由 rowSelection 提供。
 * 封面、分類、作者等欄在窄螢幕排不下，要看細節點整列開預覽即可。
 */
export const relatedMobileColumns: ColumnsType<ArticleRow> = [
  {
    title: '標題',
    dataIndex: 'title',
    render: (t: string, r) => (
      <div className="min-w-0">
        <div className="line-clamp-2 text-[14px] font-medium leading-snug text-gray-800">{t}</div>
        <div className="mt-1 flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-xs text-gray-500">
          <StatusBadge status={r.status} />
          <span aria-hidden="true" className="text-gray-300">·</span>
          <span>{fmtTaipei(r.publishedAt ?? r.updatedAt).slice(0, 10)}</span>
        </div>
      </div>
    ),
  },
];
